import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DefaultValuesService } from 'src/app/services/defaultvalues.service';
import { EquipmentManagenementService } from 'src/app/services/equipmentmanagement.service';
import { EmtTdcDeploymentStatusPopup } from '../../emttdcdeployment/emttdc-deploymentstatus-popup.component';
import { EmtconfigurationListComponent } from './emtconfiguration-list/emtconfiguration-list.component';

@Component({
    selector: 'unitactivation',
    templateUrl: './unitactivation.component.html',
    styleUrls: ['./unitactivation.component.less', '../../../../style/new-generic-styles.component.less', '../fieldsettings.component.less'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class UnitActivationComponent implements OnInit {
    title = "Equipment Management Configuration";
    selectedLevel = {} as EquipmentConfigurationLevel
    userLevels: EquipmentConfigurationLevel[] = [];

    @ViewChild(EmtconfigurationListComponent) list!: EmtconfigurationListComponent;
    constructor(
        private emtService: EquipmentManagenementService,
        public defaults: DefaultValuesService,
        private matDialog: MatDialog
    ) { }

    ngOnInit() {
        // let newLevel : EquipmentConfigurationLevel = {
        //   tenantId : "ES",
        //   branchNumber: "001",
        //   deviceId: '009'
        // };
        // this.selectedLevel = newLevel;
    }

    onNewLevelSelected(level: EquipmentConfigurationLevel) {
        this.selectedLevel = level;
        this.list.changeSelectedLevel(level);
    }

    openDeploymentInformationPopup() {
        this.matDialog.open(EmtTdcDeploymentStatusPopup, {
            panelClass: 'custom-mat-dialog',
            data: { "component": 'emttdc' }
        });
    }
}
